import React, { Component } from "react";
import localStorageService from "./services/localStorageService";
import dashboardRoutes from "./views/dashboard/DashboardRoutes";

let name = "";
let navigation = [];

class navigations {

  // const array = localStorageService.getItem("auth_user").role;
  // for(var i=0; i< array.length;i++){
  //   if(array[i]!==="offline_access" && array[i]!= "uma_authorization"){
  //     name = localStorageService.getItem("auth_user").role[i];
  //   }

  // }


  getlogednUserRoles() {
    navigation = [];
    var menu = [
      {
        name: "Dashboard",
        role: ['Super Admin', 'Admin', 'Moderator', 'Report Analysis', 'Data Entry'],
        navigation: {
          name: "Dashboard",
          path: "/dashboard/analytics",
          icon: "dashboard",

        },
      },
      {
        name: "Incidents",
        role: ['Super Admin', 'Admin', 'Moderator', 'Report Analysis', 'Data Entry'],
        navigation: {
          name: "Reported Incidents",
          icon: "trending_up",
          children: [
            {
              name: "Stories",
              icon: "trending_up",
              path: "/dashboard/Incidents/allstories"
            },
            {
              name: "Reports",
              icon: "trending_up",
              path: "/dashboard/Incidents/allreports"
            },
            {
              name: "Election Violations",
              icon: "trending_up",
              path: "/dashboard/Incidents/allelection"
            },
            {
              name: "Election Time Change",
              icon: "trending_up",
              path: "/dashboard/election/changeStatus"
            },
          ]
        }
      },
      {
        name: "News",
        role: ['Super Admin', 'Admin', 'Moderator', 'Report Analysis'],
        navigation: {
          name: "News",
          icon: "public_icon",
          children: [
            {
              name: "All News",
              icon: "trending_up",
              path: "/dashboard/News/allnews"
            },
            {
              name: "Add News",
              icon: "add_to_photos",
              path: "/dashboard/News/create"
            },
          ]
        }
      },
      {
        name: "Users",
        role: ['Super Admin', 'Admin', 'Moderator', 'Data Entry'],
        navigation: {
          name: "Users",
          icon: "person",
          children: [
            {
              name: "Create New User",
              icon: "person_add",
              path: "/dashboard/user/create"
            },
            {
              name: "Create Coordinator",
              icon: "record_voice_over",
              path: "/dashboard/user/district_coordinator/create"
            },
            {
              name: "View all users",
              icon: "group",
              path: "/dashboard/user/all"
            },

          ]
        }
      },
      {
        name: "Reports",
        role: ['Super Admin', 'Admin', 'Moderator', 'Report Analysis'],
        navigation: {
          name: "Report",
          icon: "assessmentIcon",
          path: "/dashboard/report",
        }
      },

    ]

    var roles = [];

    if (localStorageService.getItem("auth_user") !== null) {
      roles = localStorageService.getItem("auth_user").roles;
    }

    if (roles !== undefined) {
      const userpermission = roles.map(roles => roles).flat();
      menu.forEach(menuitem => {
        var count = 0;
        menuitem.role.forEach(menurole => {
          if (userpermission.find(p => p === menurole)) {
            if (count === 0) {
              count++;
              navigation.push(menuitem.navigation)
            }

          }
        })
      })
    }
  }

  getNavigation() {

    this.getlogednUserRoles();

    return navigation;
  }


}
export default new navigations();

